module.exports = __webpack_public_path__ + "img/emptyCart.d4927042.png";